<template>
  <label>
    <fhir-reference-report
        v-if="expression === 'dutyPost'"
        baseMax="1"
        baseMin="0"
        constraints="undefined"
        edit="true"
        field="partOf"
        initialValue="Location/federal-ministry-of-health"
        label="Facility"
        max="1"
        min="0"
        overrideValue="undefined"
        path="Location.partOf"
        readOnlyIfSet:undefined
        sliceName:undefined
        slotProps:Object
        source:Object
        subFields:undefined
        targetProfile="http://ihris.org/fhir/StructureDefinition/ihris-facility"
        targetResource="Location"
        returnAll = false
        @selectedFacility="onSelectedFacility"
    ></fhir-reference-report>
    <v-autocomplete
        v-else-if="isDropDown && !hideFilters"
        v-model="value"
        :error="error"
        :error-messages="err_messages"
        :items="items"
        :label="label"
        :loading="loading"
        class="ma-1"
        clearable
        dense
        hide-details
        item-text="display"
        item-value="code"
        multiple
        outlined
        small-chips
        @change="updateSearch()"
        @click:clear="clearSearch()"
    >
      <template v-slot:prepend-item>
        <v-radio-group v-model="filterType" row @change="updateSearch()">
          <v-radio label="Include" value="include"></v-radio>
          <v-radio label="Exclude" value="exclude"></v-radio>
        </v-radio-group>
        <v-divider></v-divider>
      </template>
    </v-autocomplete>
    <template v-else-if="!hideFilters">
      <template v-if="filterDataType == 'date'">
        <v-container>
          <v-layout  reverse row wrap style="max-height: 48px">
            <v-select
                style="max-width: 258px;"
                v-model="filters"
                :items="comparisons"
                :label="`${label} is`"
                class="mt-1 mx-1"
                dense
                item-text="text"
                item-value="value"
                outlined
                @input="updateSearch"
                @change="changeFilter"
            >
            </v-select>
            <v-menu
                ref="menu"
                v-model="dateMenu"
                :close-on-content-click="false"
                min-width="auto"
                offset-y
                transition="scale-transition"
            >
              <!-- <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="value"
                  :label="label"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  dense
                  outlined
                  hide-details
                  shaped
                  @input="updateSearch"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="value"
                :max="new Date().toISOString().substr(0, 10)"
                min="1950-01-01"
                @change="updateSearch"
              ></v-date-picker>
            </v-menu>-->
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="value"
                    :label="label"
                    class="ma-1"
                    clearable
                    dense
                    hide-details="auto"
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    @input="updateSearch"
                    v-on="on"
                >
                </v-text-field>
              </template>
              <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                  <v-card min-width="300px">
                    <v-card-title class="primary white--text">
                      Ethiopian Calendar
                      <v-spacer/>
                      <v-btn
                          class="white--text"
                          dark
                          group
                          icon
                          small
                          @click="showGregorian = !showGregorian"
                      >
                        <v-icon v-if="!showGregorian"
                        >mdi-calendar-multiple
                        </v-icon>
                        <v-icon v-else>mdi-calendar</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text v-if="pickerType === 'year'">
                      <br/>
                      <v-text-field
                          v-model="etValue"
                          :disabled="disabled"
                          :error-messages="errors"
                          :label="label"
                          :max="maxYearET"
                          :min="minYearET"
                          :rules="rules"
                          class="ma-1"
                          clearable
                          dense
                          type="number"
                          @change="updateSearch"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-ethiopian-date-picker
                        v-else
                        ref="etPicker"
                        v-model="etValue"
                        :disabled="disabled"
                        :landscape="$vuetify.breakpoint.smAndUp"
                        :max="maxValueETDate"
                        :min="minValueETDate"
                        :type="filterDataType"
                        color="secondary"
                        label="Ethiopian"
                        locale="am"
                        @change="updateSearch"
                    ></v-ethiopian-date-picker>
                  </v-card>
                  <v-card v-if="showGregorian" min-width="300px">
                    <v-card-title class="primary white--text">
                      Gregorian Calendar
                      <v-spacer/>
                      <v-btn
                          class="white--text"
                          dark
                          group
                          icon
                          small
                          @click="showGregorian = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text v-if="pickerType === 'year'">
                      <br/>
                      <v-text-field
                          v-model="value"
                          :disabled="disabled"
                          :error-messages="errors"
                          :label="label"
                          :max="maxYear"
                          :min="minYear"
                          :rules="rules"
                          class="ma-1"
                          clearable
                          dense
                          type="number"
                          @change="updateSearch"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-date-picker
                        v-else
                        ref="gPicker"
                        v-model="value"
                        :disabled="disabled"
                        :landscape="$vuetify.breakpoint.smAndUp"
                        :max="dateValueMax"
                        :min="dateValueMin"
                        :type="filterDataType"
                        color="secondary"
                        @change="updateSearch"
                    ></v-date-picker>
                  </v-card>
                </v-row>
              </v-container>
            </v-menu>
          </v-layout>
        </v-container>
      </template>
      <v-text-field
          v-else
          v-model="inputValueText"
          :label="label"
          class="ma-1"
          clearable
          dense
          hide-details
          outlined
          prepend-inner-icon="mdi-filter-variant"
      />
    </template>
  </label>
</template>

<script>
import VEthiopianDatePicker from "vuetify-ethiopian-calendar";
import ethiopic from "ethiopic-calendar";
import {eventBus} from "@/main";
import FhirReferenceReport from "../fhir/fhir-referense-report";

export default {
  name: "ihris-search-term",
  props: [
    "label",
    "expression",
    "isDropDown",
    "reportData",
    "hideFilters",
    "calendar",
  ],
  components: {
    FhirReferenceReport,
    VEthiopianDatePicker,
  },
  data: function () {
    return {
      loading: false,
      items: [],
      error: false,
      err_messages: null,
      filterType: "include",
      value: null,
      inputValue: null,
      inputValueText: null,
      sample: "",
      etValue: null,
      filterDataType: "",
      pickerType: "date",
      menu: false,
      dateMenu: false,
      showGregorian: false,
      selectedRegion: "",
      selectedZone: "",
      selectedWoreda: "",
      selection: [],
      dutyPost: [],
      disabled: false,
      filters:null,
      comparisons: [
        {value: null, text: "Equals"},
        {value: "gte", text: "Greater than or equal to"},
        {value: "gt", text: "Greater than"},
        {value: "lt", text: "Less than"},
        {value: "lte", text: "Less than or equal to"},
      ],
    };
  },
  mounted: function () {
    if (this.expression === "parentRegion") {
      if (this.isDropDown && this.filterDataType) {
        this.loading = true;
        let url = `/fhir/Location?partof=Location%2FET&_sort=name`;
        fetch(url, {
          method: "GET",
        })
            .then((response) => {
              response
                  .json()
                  .then((data) => {
                    this.loading = false;
                    for (let bucket of data.entry) {
                      this.items.push(bucket.resource.name);
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.error_message = "Unable to load results.";
                    console.log(err);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.error_message = "Unable to load results.";
              console.log(err);
            });
      }
    }
    eventBus.$on("changedTerms", (data) => {
      if (data.parentRegion) {
        this.selectedRegion = data.parentRegion;
      }
      if (data.parentZone) {
        this.selectedZone = data.parentZone;
      }
      if (data.parentWoreda) {
        this.selectedWoreda = data.parentWoreda;
      }
    });

    if (this.reportData.mappings.mappings.properties[this.expression]) {
      this.filterDataType =
          this.reportData.mappings.mappings.properties[this.expression].type;
    }
    let location = ["parentRegion", "parentZone", "parentWoreda", "dutyPost"];
    if (this.expression === location[0]) {
      if (this.isDropDown) {
        this.loading = true;
        let url = `/fhir/Location?partof=Location%2FET&_sort=name`;
        fetch(url, {
          method: "GET",
        })
            .then((response) => {
              response
                  .json()
                  .then((data) => {
                    this.loading = false;
                    for (let bucket of data.entry) {
                      this.items.push(bucket.resource.name);
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.error_message = "Unable to load results.";
                    console.log(err);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.error_message = "Unable to load results.";
              console.log(err);
            });
      }
    } else if (this.expression === location[1]) {
      if (this.isDropDown && this.filterDataType) {
        this.loading = false;
        if (this.selectedRegion) {
          this.loading = false;
        }
      }
    } else if (this.expression === location[2]) {
      if (this.isDropDown && this.filterDataType) {
        this.loading = false;
      }
    } else {
      this.loading = true;

      let url = `/es/populateFilter/${this.reportData.indexName}/${this.expression}?dataType=${this.filterDataType}`;
      if (this.expression == "department") {
        url = `/es/populateFilter/${this.reportData.indexName}/facility?dataType=text`;
      }
      fetch(url, {
        method: "GET",
      })
          .then((response) => {
            response
                .json()
                .then((data) => {
                  this.loading = false;
                  for (let bucket of data) {
                    this.items.push(bucket.key.value);
                  }
                })
                .catch((err) => {
                  this.loading = false;
                  this.error_message = "Unable to load results.";
                  console.log(err);
                });
          })
          .catch((err) => {
            this.loading = false;
            this.error_message = "Unable to load results.";
            console.log(err);
          });
    }
  },
  methods: {
    onSelectedFacility: function (val) {
      this.$emit("termChange", this.expression, val, this.filterType);
    },
    updateSearch: function () {
      this.$emit("termChange", this.expression, this.value, this.filterType);
    },
    clearSearch: function () {
      this.$emit("termChange", this.expression, []);
    },
    convertQuantity(val, direction) {
      const unitsofmeasure = {
        a: "years",
        mo: "months",
        wk: "weeks",
        d: "days",
      };
      const quant = /(-?\d+)([a-z]{1,3})/;

      let match = val.match(quant);
      if (match.length === 3) {
        try {
          let value = match[1];
          let unit = unitsofmeasure[match[2]];
          if (direction === "subtract") {
            return this.$moment(this.$moment().subtract(value, unit)).format(
                "YYYY-MM-DD"
            );
          } else {
            return this.$moment(this.$moment().add(value, unit)).format(
                "YYYY-MM-DD"
            );
          }
        } catch (e) {
          console.log("Failed to get date from quantity", e);
        }
      }
      return undefined;
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
    convertEG(val) {
      if (!val) return val;
      const [etYear, etMonth, etDay] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let gDate = ethiopic.eg(etYear, etMonth || 6, etDay || 1); // so it will be the same year in both directions
        return gDate.year.toString().padStart(4, "0");
      } else {
        let gDate = ethiopic.eg(etYear, etMonth || 1, etDay || 1);
        return (
            gDate.year.toString().padStart(4, "0") +
            "-" +
            gDate.month.toString().padStart(2, "0") +
            "-" +
            gDate.day.toString().padStart(2, "0")
        );
      }
    },
    save(date) {
      this.errors = [];
      this.$refs.menu.save(date);
    },
    changeFilter(value){
      this.filterType = value;
      this.$emit("termChange", this.expression, this.value, this.filterType);
    }
  },
  computed: {
    dateValueMax: function () {
      if (this.maxValueQuantity) {
        let maxDate = this.convertQuantity(this.maxValueQuantity, "add");
        if (maxDate) {
          return maxDate;
        }
      }
      if (this.maxValueDate) {
        return this.maxValueDate;
      }
      return undefined;
    },
    dateValueMin: function () {
      if (this.minValueQuantity) {
        let minDate = this.convertQuantity(this.minValueQuantity, "subtract");
        if (minDate) {
          return minDate;
        }
      } else if (this.minValueDate) {
        return this.minValueDate;
      }
      return undefined;
    },
    minYear: function () {
      return this.dateValueMin ? this.dateValueMin.substring(0, 4) : undefined;
    },
    maxYear: function () {
      return this.dateValueMax ? this.dateValueMax.substring(0, 4) : undefined;
    },
    minYearET: function () {
      return this.minValueETDate
          ? this.minValueETDate.substring(0, 4)
          : undefined;
    },
    maxYearET: function () {
      return this.maxValueETDate
          ? this.maxValueETDate.substring(0, 4)
          : undefined;
    },
    isEthiopian: function () {
      return this.calendar === "Ethiopian";
    },
    minValueETDate: function () {
      if (this.dateValueMin) {
        return this.convertGE(this.dateValueMin);
      } else {
        return null;
      }
    },
    maxValueETDate: function () {
      if (this.dateValueMax) {
        return this.convertGE(this.dateValueMax);
      } else {
        return null;
      }
    },
    displayValue: function () {
      if (this.isEthiopian) {
        return (
            this.value &&
            "Ethiopian: " + this.etValue + " Gregorian: " + this.value
        );
      } else {
        return this.value;
      }
    },
  },
  watch: {
    inputValue() {
      this.$emit(
          "termChange",
          this.expression,
          this.inputValue,
          this.filterType
      );
    },
    inputValueText() {
      this.$emit(
          "termChange",
          this.expression,
          this.inputValueText.toString().toLowerCase(),
          this.filterType
      );
    },
    selectedRegion() {
      if (this.expression === "parentZone") {
        this.items = [];
        let regionUrl = `/fhir/Location?name:exact=${this.selectedRegion}&partof=ET&_pretty=true`;
        fetch(regionUrl, {
          method: "GET",
        })
            .then((response) => {
              response
                  .json()
                  .then((data) => {
                    let url = `/fhir/Location/?partof=${data.entry[0].resource.id}&_sort=name`;
                    fetch(url, {
                      method: "GET",
                    })
                        .then((response) => {
                          response
                              .json()
                              .then((data) => {
                                this.loading = false;

                                for (let bucket of data.entry) {
                                  this.items.push(bucket.resource.name);
                                }
                              })
                              .catch((err) => {
                                this.loading = false;
                                this.error_message = "Unable to load results.";
                                console.log(err);
                              });
                        })
                        .catch((err) => {
                          this.loading = false;
                          this.error_message = "Unable to load results.";
                          console.log(err);
                        });
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.error_message = "Unable to load results.";
                    console.log(err);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.error_message = "Unable to load results.";
              console.log(err);
            });
      }
    },
    selectedZone() {
      if (this.expression === "parentWoreda") {
        this.items = [];
        let dataId = this.selectedZone[0];
        let regionUrl = `/fhir/Location?name:exact=${dataId}&_pretty=true`;

        fetch(regionUrl, {
          method: "GET",
        })
            .then((response) => {
              response
                  .json()
                  .then((data) => {
                    let id = "";
                    if (data.entry && data.entry.length > 0) {
                      data.entry.forEach((entry) => {
                        if (entry.resource.id.split(".").length === 3) {
                          id = entry.resource.id;
                        }
                      });
                    } else {
                      id = data.entry[0].resource.id;
                    }
                    let url = `/fhir/Location/?partof=${id}&_sort=name`;
                    fetch(url, {
                      method: "GET",
                    })
                        .then((response) => {
                          response
                              .json()
                              .then((data) => {
                                this.loading = false;
                                for (let bucket of data.entry) {
                                  if (bucket.resource.type.length > 0) {
                                    for (
                                        let i = 0;
                                        i < bucket.resource.type.length;
                                        i++
                                    ) {
                                      if (
                                          bucket.resource.type[0].coding[0].code ===
                                          "woreda"
                                      ) {
                                        this.items.push(bucket.resource.name);
                                      }
                                    }
                                  }
                                  // this.items.push(bucket.resource.name);
                                }
                              })
                              .catch((err) => {
                                this.loading = false;
                                this.error_message = "Unable to load results.";
                                console.log(err);
                              });
                        })
                        .catch((err) => {
                          this.loading = false;
                          this.error_message = "Unable to load results.";
                          console.log(err);
                        });
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.error_message = "Unable to load results.";
                    console.log(err);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.error_message = "Unable to load results.";
              console.log(err);
            });
      }
      if (this.selectedZone && this.expression === "dutyPost") {
        console.log(this.irems);
        this.items = [];
        let dataId = this.selectedZone[0];
        let regionUrl = `/fhir/Location?name:exact=${dataId}&_pretty=true`;

        fetch(regionUrl, {
          method: "GET",
        })
            .then((response) => {
              response
                  .json()
                  .then((data) => {
                    let id = "";
                    if (data.entry && data.entry.length > 0) {
                      data.entry.forEach((entry) => {
                        if (entry.resource.id.split(".").length === 3) {
                          id = entry.resource.id;
                        }
                      });
                    } else {
                      id = data.entry[0].resource.id;
                    }
                    let url = `/fhir/Location/?partof=${id}&_sort=name`;
                    fetch(url, {
                      method: "GET",
                    })
                        .then((response) => {
                          response
                              .json()
                              .then((data) => {
                                this.loading = false;
                                for (let bucket of data.entry) {
                                  if (bucket.resource.type.length > 0) {
                                    for (
                                        let i = 0;
                                        i < bucket.resource.type.length;
                                        i++
                                    ) {
                                      if (bucket.resource.type[i].text === "Facility") {
                                        this.items.push(bucket.resource.name);
                                      }
                                      if (
                                          bucket.resource.type[0].coding[0].code ===
                                          "woreda"
                                      ) {
                                        let id = bucket.resource.partOf.reference;
                                        fetch(
                                            `/fhir/Location/?partof=${id}&_sort=name`,
                                            {
                                              method: "GET",
                                            }
                                        ).then((response) => {
                                          response
                                              .json()
                                              .then((data) => {
                                                this.loading = false;

                                                for (let bucket of data.entry) {
                                                  if (bucket.resource.type.length > 0) {
                                                    for (
                                                        let i = 0;
                                                        i < bucket.resource.type.length;
                                                        i++
                                                    ) {
                                                      if (
                                                          bucket.resource.type[i].text ===
                                                          "Facility"
                                                      ) {
                                                        this.items.push(
                                                            bucket.resource.name
                                                        );
                                                      }
                                                    }
                                                  }
                                                }
                                              })
                                              .catch((err) => {
                                                this.loading = false;
                                                this.error_message =
                                                    "Unable to load results.";
                                                console.log(err);
                                              });
                                        });
                                      }
                                    }
                                  }
                                }
                              })
                              .catch((err) => {
                                this.loading = false;
                                this.error_message = "Unable to load results.";
                                console.log(err);
                              });
                        })
                        .catch((err) => {
                          this.loading = false;
                          this.error_message = "Unable to load results.";
                          console.log(err);
                        });
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.error_message = "Unable to load results.";
                    console.log(err);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.error_message = "Unable to load results.";
              console.log(err);
            });
      }
    },
    selectedWoreda() {
      if (this.selectedWoreda && this.expression === "dutyPost") {
        this.items = [];
        let dataId = this.selectedWoreda[0];
        let regionUrl = `/fhir/Location?name:exact=${dataId}&_pretty=true`;

        fetch(regionUrl, {
          method: "GET",
        })
            .then((response) => {
              response
                  .json()
                  .then((data) => {
                    let id = "";
                    if (data.entry && data.entry.length > 0) {
                      data.entry.forEach((entry) => {
                        if (entry.resource.id.split(".").length === 3) {
                          id = entry.resource.id;
                        }
                      });
                    } else {
                      id = data.entry[0].resource.id;
                    }
                    let url = `/fhir/Location/?partof=${id}&_sort=name`;
                    fetch(url, {
                      method: "GET",
                    })
                        .then((response) => {
                          response
                              .json()
                              .then((data) => {
                                this.loading = false;
                                for (let bucket of data.entry) {
                                  if (bucket.resource.type.length > 0) {
                                    for (
                                        let i = 0;
                                        i < bucket.resource.type.length;
                                        i++
                                    ) {
                                      if (bucket.resource.type[i].text === "Facility") {
                                        this.items.push(bucket.resource.name);
                                      }
                                      if (
                                          bucket.resource.type[0].coding[0].code ===
                                          "woreda"
                                      ) {
                                        let id = bucket.resource.partOf.reference;
                                        fetch(
                                            `/fhir/Location/?partof=${id}&_sort=name`,
                                            {
                                              method: "GET",
                                            }
                                        ).then((response) => {
                                          response
                                              .json()
                                              .then((data) => {
                                                this.loading = false;
                                                for (let bucket of data.entry) {
                                                  if (bucket.resource.type.length > 0) {
                                                    for (
                                                        let i = 0;
                                                        i < bucket.resource.type.length;
                                                        i++
                                                    ) {
                                                      if (
                                                          bucket.resource.type[i].text ===
                                                          "Facility"
                                                      ) {
                                                        this.items.push(
                                                            bucket.resource.name
                                                        );
                                                      }
                                                    }
                                                  }
                                                }
                                              })
                                              .catch((err) => {
                                                this.loading = false;
                                                this.error_message =
                                                    "Unable to load results.";
                                                console.log(err);
                                              });
                                        });
                                      }
                                    }
                                  }
                                }
                              })
                              .catch((err) => {
                                this.loading = false;
                                this.error_message = "Unable to load results.";
                                console.log(err);
                              });
                        })
                        .catch((err) => {
                          this.loading = false;
                          this.error_message = "Unable to load results.";
                          console.log(err);
                        });
                  })
                  .catch((err) => {
                    this.loading = false;
                    this.error_message = "Unable to load results.";
                    console.log(err);
                  });
            })
            .catch((err) => {
              this.loading = false;
              this.error_message = "Unable to load results.";
              console.log(err);
            });
      }
    },
    menu(val) {
      if (this.isEthiopian) {
        !this.value &&
        val &&
        setTimeout(() => (this.$refs.etPicker.activePicker = "YEAR"));
      } else {
        !this.value &&
        val &&
        setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      }
    },
    showGregorian(val) {
      !this.value &&
      val &&
      setTimeout(() => (this.$refs.gPicker.activePicker = "YEAR"));
    },
    value(val) {
      if (!val) {
        this.etValue = val;
      } else if (this.pickerType === "year") {
        if (val.length === 4) {
          this.etValue = this.convertGE(val);
        }
      } else {
        this.etValue = this.convertGE(val);
      }
    },
    etValue(val) {
      if (!val) {
        this.value = val;
      } else if (this.pickerType === "year") {
        if (val.length === 4) {
          this.value = this.convertEG(val);
        }
      } else {
        this.value = this.convertEG(val);
      }
    },
  },
};
</script>
